/* Nelson workbench (2026-10-15, v2). Design: PDP canvas board "Locked workbench".
 * Turns the PDP's vertical accordion into four tabs (Colour · Logo · Sizes · Review) under the price card.
 * On screens >= 1000 x 600 the whole customiser is one screen tall: the photo fits the height, the right
 * rail never grows, the active step scrolls inside the rail, and Next never scrolls the page.
 *
 * Add-on, like nelson-method-plate.js: piobox-pdp.js is untouched (the live bundle has drifted from the
 * repo source). Tabs press the PDP's own hidden [data-next] / [data-openstep] buttons, so the PDP stays the
 * single source of truth for step, price, logo and cart. Tab subtitles reuse the PDP's step summaries. */
(function () {
  "use strict";
  var LABEL = { 1: "Colour", 2: "Logo", 3: "Sizes", 4: "Review" };
  var LOCK = window.matchMedia("(min-width: 1000px) and (min-height: 600px)");
  var DOC = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M9 8h6M9 12h6M9 16h3"/></svg>';
  var TICK = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>';
  var txt = function (el) { return el ? (el.textContent || "").replace(/\s+/g, " ").trim() : ""; };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var setHTML = function (el, html) { if (el.__h !== html) { el.innerHTML = html; el.__h = html; } };

  function mount(root) {
    var panel = root.querySelector(".pbx-panel");
    var summary = root.querySelector(".pbx-summary");
    var boxes = [].slice.call(root.querySelectorAll(".pbx-step[data-stepbox]"));
    if (!panel || !summary || !boxes.length) return false;

    var steps = boxes.map(function (b) { return +b.dataset.stepbox; }).concat(4);
    var timer = null;

    var body = document.createElement("div");
    body.className = "nwb-body";
    boxes[0].insertAdjacentElement("beforebegin", body);
    boxes.concat(summary).forEach(function (el) { body.appendChild(el); });

    var tabs = document.createElement("div");
    tabs.className = "nwb-tabs";
    tabs.setAttribute("role", "tablist");
    tabs.setAttribute("aria-label", "Customise steps");
    body.insertAdjacentElement("beforebegin", tabs);

    var foot = document.createElement("div");
    foot.className = "nwb-foot";
    // "Add to quote" wears the header's stitched pill, so quote reads as one thing across the site.
    // [data-quote] is what pbq-pdp.js listens for: one click saves the whole design to the quote list.
    // data-pbq="1" stops pbq-pdp.js relabelling it.
    var navQuote = document.querySelector(".pbx-nav__quote svg.pbi-g");
    var qIcon = navQuote ? navQuote.outerHTML : DOC;
    foot.innerHTML = '<div class="nwb-tot"><span class="nwb-k" data-nwb-each></span><b data-nwb-total></b></div>' +
      '<button type="button" class="nwb-quote pbi-stitch" data-quote data-pbq="1" title="Save this design to your quote and get a final price">' + qIcon +
      '<span>Add to quote</span><svg class="pbi-st" aria-hidden="true" focusable="false"><rect class="hole"/><rect class="run"/></svg></button>' +
      '<button type="button" class="pbx-btn pbx-btn--pri nwb-next" data-nwb-next></button>';
    panel.appendChild(foot);
    var quoteBtn = foot.querySelector(".nwb-quote");
    quoteBtn.setAttribute("aria-label", "Add this design to your quote");

    // Size the stitch to the pill, the same geometry as the header button (3.5px inset, round ends).
    function stitch() {
      var w = quoteBtn.offsetWidth, h = quoteBtn.offsetHeight;
      if (!w || !h) return;
      var sv = quoteBtn.querySelector("svg.pbi-st");
      sv.setAttribute("width", w); sv.setAttribute("height", h); sv.setAttribute("viewBox", "0 0 " + w + " " + h);
      [].forEach.call(sv.querySelectorAll("rect"), function (r) {
        r.setAttribute("x", 3.5); r.setAttribute("y", 3.5); r.setAttribute("width", w - 7); r.setAttribute("height", h - 7); r.setAttribute("rx", (h - 7) / 2);
      });
    }
    if (window.ResizeObserver) new ResizeObserver(stitch).observe(quoteBtn);
    stitch();
    // When a line lands on the quote, sew the stitch once.
    document.addEventListener("pbq:change", function () {
      quoteBtn.classList.remove("is-sewing");
      void quoteBtn.offsetWidth;
      quoteBtn.classList.add("is-sewing");
      setTimeout(function () { quoteBtn.classList.remove("is-sewing"); }, 1500);
    });

    root.classList.add("nwb");

    function current() {
      var open = root.querySelector(".pbx-step.is-open[data-stepbox]");
      return open ? +open.dataset.stepbox : 4; // the PDP closes every step on its review (step 4)
    }

    // The theme scrolls inside .page-wrapper, not the window: scroll whatever actually scrolls.
    function scroller(el) {
      for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
        var oy = getComputedStyle(p).overflowY;
        if ((oy === "auto" || oy === "scroll") && p.scrollHeight > p.clientHeight) return p;
      }
      return null;
    }
    function align() {
      if (!LOCK.matches) { tabs.scrollIntoView({ behavior: "smooth", block: "start" }); return; }
      var grid = root.querySelector(".pbx-grid");
      var dy = (grid ? grid.getBoundingClientRect().top : 12) - 12;
      if (Math.abs(dy) < 4) return;
      var sc = scroller(grid);
      if (sc) sc.scrollBy({ top: dy, behavior: "smooth" });
      else window.scrollBy({ top: dy, behavior: "smooth" });
    }

    function go(n) {
      var now = current();
      if (n === now) return;
      if (n === 1) { var h = root.querySelector('[data-openstep="1"]'); if (h) h.click(); }
      else { var b = root.querySelector('[data-next="' + n + '"]'); if (b) b.click(); }
      body.scrollTop = 0;
      align();
    }

    // The PDP scrolls the page to each step it opens. Inside the workbench, scroll within the rail instead.
    var native = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () {
      if (body.contains(this)) {
        if (LOCK.matches) {
          var r = this.getBoundingClientRect(), br = body.getBoundingClientRect();
          body.scrollTop += r.top - br.top - 8;
        } else native.call(tabs, { behavior: "smooth", block: "start" });
        return;
      }
      return native.apply(this, arguments);
    };

    tabs.addEventListener("click", function (e) {
      var b = e.target.closest("[data-nwb-tab]");
      if (!b) return;
      e.stopPropagation();
      go(+b.dataset.nwbTab);
    });
    foot.addEventListener("click", function (e) {
      if (!e.target.closest("[data-nwb-next]")) return;
      e.stopPropagation();
      var i = steps.indexOf(current());
      if (i < steps.length - 1) go(steps[i + 1]);
      else { var p = root.querySelector("[data-primary]"); if (p && !p.disabled) p.click(); }
    });
    tabs.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
      var i = steps.indexOf(current()) + (e.key === "ArrowRight" ? 1 : -1);
      if (i < 0 || i >= steps.length) return;
      e.preventDefault();
      go(steps[i]);
      var t = tabs.querySelector('[data-nwb-tab="' + steps[i] + '"]');
      if (t) t.focus();
    });

    // Single-size products (bottles, bags) count pieces, not sizes.
    function label(n) { return n === 3 && root.querySelector('[data-stepbox="3"] .pbx-one') ? "Quantity" : LABEL[n]; }

    function render() {
      var cur = current(), ci = steps.indexOf(cur);
      root.dataset.nwbTab = String(cur);
      boxes.forEach(function (b) { b.classList.toggle("nwb-cur", +b.dataset.stepbox === cur); });
      var total = txt(root.querySelector("[data-bartot]"));
      setHTML(tabs, steps.map(function (n, i) {
        var on = n === cur, done = i < ci;
        var sum = n === 4 ? total : txt(root.querySelector("[data-sum" + n + "]"));
        return '<button type="button" role="tab" class="nwb-tab' + (on ? " is-on" : "") + (done ? " is-done" : "") + '" aria-selected="' + on + '" tabindex="' + (on ? 0 : -1) + '" data-nwb-tab="' + n + '">' +
          '<span class="nwb-n">0' + (i + 1) + (done ? " " + TICK : "") + '</span><span class="nwb-l">' + label(n) + '</span><span class="nwb-s">' + esc(sum || "-") + "</span></button>";
      }).join(""));
      // The per-piece price lives in the footer, so it stays visible when the price card collapses.
      var each = txt(root.querySelector(".nlp .nlp-main > :first-child")), qty = txt(root.querySelector("[data-sum3]"));
      var kicker = each ? each + " each" + (qty ? " · " + qty : "") : "Your order";
      var k = foot.querySelector("[data-nwb-each]");
      if (k.textContent !== kicker) k.textContent = kicker;
      // Colour names are hidden on the compact swatches: keep them as hover labels.
      root.querySelectorAll(".pbx-sw").forEach(function (b) { var s = b.querySelector("span"); if (s && !b.title) b.title = txt(s); });
      var t = foot.querySelector("[data-nwb-total]");
      if (t.textContent !== total) t.textContent = total;
      var nx = foot.querySelector("[data-nwb-next]");
      var nextText = ci < steps.length - 1 ? "Next: " + label(steps[ci + 1]) : txt(root.querySelector("[data-primary]")) || "Add to cart";
      if (nx.textContent !== nextText) nx.textContent = nextText;
    }

    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var n = list[i].target;
        if (!tabs.contains(n) && !foot.contains(n)) { clearTimeout(timer); timer = setTimeout(render, 40); return; }
      }
    }).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["class", "hidden", "disabled"] });
    render();
    return true;
  }

  function start() {
    var tries = 0;
    var iv = setInterval(function () {
      var root = document.querySelector(".pbx-pdp [id^=pbx-pdp-]");
      if ((root && !root.classList.contains("nwb") && mount(root)) || ++tries > 150) clearInterval(iv);
    }, 100);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();